import {
  Box,
  Fade,
  ListItemText,
  makeStyles,
  MenuItem,
  MenuList,
  Popover,
} from '@material-ui/core';
import { selectAuthenticationInfo } from '@src/selectors/user';
import { LoginSuccess } from '@src/types';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import {
  AdminAction,
  LogoutAction,
  NotificationsAnnounceKitAction,
} from './actions';
import { AvatarWithStatusMenu } from './Utils';

const useStyles = makeStyles(theme => ({
  popover: {
    '& .MuiMenuItem-root': {
      borderRadius: 0,
      '&:hover': {
        color: theme.palette.text.primary,
        backgroundColor: `${theme.b2chatgray[400]} !important`,
      },
    },
  },
}));

const HeaderTightMenu: React.FC<React.PropsWithChildren<unknown>> = ({
  children,
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const { popover } = useStyles();

  const user: LoginSuccess = useSelector(selectAuthenticationInfo);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      {React.cloneElement(children as React.ReactElement, {
        onClick: handleClick,
      })}

      <Popover
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        elevation={0}
        keepMounted
        TransitionComponent={Fade}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        PaperProps={{
          style: { width: 221 },
        }}
        className={popover}
      >
        <MenuList>
          <MenuItem>
            <ListItemText
              primary={
                <Box display="flex" style={{ gap: 9 }}>
                  <AvatarWithStatusMenu />
                </Box>
              }
            />
          </MenuItem>

          <MenuItem>
            <ListItemText
              primary={<NotificationsAnnounceKitAction displayIconText />}
            />
          </MenuItem>

          <MenuItem>
            <ListItemText
              primary={<AdminAction displayIconText user={user} />}
            />
          </MenuItem>

          <MenuItem>
            <ListItemText primary={<LogoutAction displayIconText />} />
          </MenuItem>
        </MenuList>
      </Popover>
    </>
  );
};

export default HeaderTightMenu;
